<template>
  <!-- 统一的已读标签组件 -->
  <div class="flex items-center gap-[5px]" :class="variantClasses.container">
    <img src="../assets/stroke.png" alt="viewed" class="w-[19px] h-auto" />
    <span
      class="font-medium"
      :class="[variantClasses.text, isEnglish ? 'text-[24px]' : 'text-[20px]']"
    >
      {{ viewedText }}
    </span>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { lang } from '../utils/lang';
import $t from '../utils/i18n';
import { ELang } from '@ark/utils';

// ViewedBadge 组件：统一的已读标签样式
// 使用方式：<ViewedBadge v-if="viewed" variant="corner" />

// 语言判断

interface Props {
  // corner: 贴紧角落的样式（文章卡片、直播卡片右上角）
  // inline: 内联样式（股票卡片右下角）
  variant?: 'corner' | 'inline';
}
const __sfc_main = {};
__sfc_main.props = {
  variant: {
    key: "variant",
    required: false,
    type: String,
    default: 'corner'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const isEnglish = computed(() => lang === ELang.KV.EN);

  // 获取多语言文案
  const viewedText = computed(() => $t('ViewedBadge.text'));
  const props = __props;

  // 根据 variant 返回对应的 Tailwind 类名
  const variantClasses = computed(() => {
    if (props.variant === 'inline') {
      return {
        container: 'py-[8px] px-[10px] rounded-[5px] bg-[rgba(0,190,99,0.15)]',
        text: 'text-[#00ab59]'
      };
    }
    // corner 样式（默认）
    return {
      container: 'h-[49px] pt-[12px] pr-[12px] pb-[10px] pl-[15px] rounded-bl-[10px] bg-[#073A1E]',
      text: 'text-[#00c265]'
    };
  });
  return {
    isEnglish,
    viewedText,
    variantClasses
  };
};
export default __sfc_main;
</script>
